import { render, staticRenderFns } from "./IPSECTransportStatusList.vue?vue&type=template&id=70991ac2&"
import script from "./IPSECTransportStatusList.vue?vue&type=script&lang=js&"
export * from "./IPSECTransportStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports